import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a13a63c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "go1-align-items-center go1-grid go1-p-4 go1-pl-6 go1-mt-0" }
const _hoisted_3 = {
  style: {"word-wrap":"break-word"},
  class: "go1-col-5 go1-w-50"
}
const _hoisted_4 = { class: "go1-iconos" }
const _hoisted_5 = { class: "go1-justify-content-center go1-flex go1-align-items-center" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-hotel" })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plane" })
  ])
], -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

import IconDescabrazo from "./extra/IconDescabrazo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Descabrazos',
  props: ["data"],
  setup(__props) {

const { data } = __props;

_useCssVars(_ctx => ({
  "46d6b783": ("#" + __props.data.styles.c_message),
  "92625280": (`url("${__props.data.image.url}") `),
  "72ea50ea": ("#" + (__props.data.styles.bg || "7A9FFF"))
}))



const isAnBlock = (): boolean => {
  if (!(typeof data.block_type == "object")) {
    return false;
  }
  return true;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: __props.data?.url,
    target: "_blank",
    class: "go1-descabrazos"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.data.message), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (isAnBlock())
          ? (_openBlock(), _createBlock(IconDescabrazo, _normalizeProps(_mergeProps({ key: 0 }, __props.data.block_type)), null, 16))
          : _createCommentVNode("", true),
        (!isAnBlock())
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _hoisted_9))
          : _createCommentVNode("", true)
      ])
    ])
  ], 8, _hoisted_1))
}
}

})